// Taxonomy emitter for rupeezy-login. RudderStack is the CDP/transport — it fans
// out to GA4 / MoEngage / … downstream, so no destination routing lives in app
// code. Every value is snake_case; the verb lives only in `action`.
import { EVENTS, ACTION, type AnalyticsParams } from "./taxonomy";
import { rudderTrack, rudderIdentify } from "./rudder";

function push(event: string, props: AnalyticsParams): void {
  rudderTrack(event, props as Record<string, unknown>);
}

/** Generic element-level interaction (tap/click). Verb in `action`, never in the value. */
export function trackElement({ flow, screen, element, action = ACTION.TAPPED, ...rest }: AnalyticsParams): void {
  push(EVENTS.ELEMENT_INTERACTION, { flow, screen, action, element, ...rest });
}

/** Generic screen/surface impression (funnel backbone). */
export function trackScreen({ flow, screen, action = ACTION.VIEWED, ...rest }: AnalyticsParams): void {
  push(EVENTS.SCREEN_VIEWED, { flow, screen, action, ...rest });
}

/** Named milestone (login_succeeded, …). */
export function trackMilestone(event: string, props: AnalyticsParams): void {
  push(event, props);
}

/** Bind the current user to the analytics session (RudderStack identify). */
export function identify(userId: string, traits: Record<string, unknown> = {}): void {
  if (!userId) return;
  rudderIdentify(userId, traits);
}
